import HttpClient from "../helpers/HttpClient"
import DefaultOption, { DefaultOptionDto } from "./DefaultOption"
import { HttpError, isError } from "../helpers/Error"

class DefaultOptionService {
    httpClient: HttpClient<DefaultOption, DefaultOptionDto> = new HttpClient<DefaultOption, DefaultOptionDto>(DefaultOption)

    async RetrieveDefaultProposalOptions(): Promise<DefaultOption[] | HttpError> {
        const res = await this.httpClient.get("/default-proposal-options")
        if (isError(res)) {
            return res as HttpError
        }
        return (res as DefaultOption[])
    }

    async fetchDefaultProposalOptionsByOptionKey(optionKey: string){
        const res = await this.httpClient.get(`/default-proposal-options/${optionKey}`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as DefaultOption
    }

    async updateDefaultProposalOptions(optionKey: string, optionValue: string){
        const res = await this.httpClient.patch(`/default-proposal-options/${optionKey}`, {
            value: optionValue
        })
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as DefaultOption
    }
}

const instance = new DefaultOptionService()
export default instance


// WEBPACK FOOTER //
// ./src/state/default-option/DefaultOptionService.ts